<template>
    <section v-if="props.descriptions && props.descriptions.length" class="part-detail-section">
        <a id="part-detail-descriptions-link" class="part-detail-section-link" tabindex="-1"></a>
        <h2 class="part-page-heading">{{ $t("PartDetail.Descriptions") }}</h2>
        <div class="panel">
            <ul class="panel-body">
                <li v-for="description of descriptions" :key="description" class="py-2.5 px-4">
                    {{ description }}
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({ descriptions: { type: Array, required: true } });
</script>
